import React, { useId, useState } from 'react';

/**
 * Envio — área para soltar ou escolher arquivos. O campo de arquivo fica por dentro,
 * então funciona com teclado e leitor de tela. aoEnviar recebe a lista de arquivos.
 */
export default function Envio({ aceita, multiplo = false, aoEnviar, texto = 'Arraste arquivos aqui ou escolha no computador' }) {
  const id = useId();
  const [arrastando, setArrastando] = useState(false);

  const receber = (lista) => {
    if (lista && lista.length) aoEnviar?.(Array.from(lista));
  };

  return (
    <label
      htmlFor={id}
      className={['sj-envio', arrastando ? 'sj-envio--arrastando' : ''].filter(Boolean).join(' ')}
      onDragOver={(e) => { e.preventDefault(); setArrastando(true); }}
      onDragLeave={() => setArrastando(false)}
      onDrop={(e) => { e.preventDefault(); setArrastando(false); receber(e.dataTransfer.files); }}
    >
      <span className="sj-icone" aria-hidden="true">upload_file</span>
      <span>{texto}</span>
      <input id={id} type="file" className="sj-oculto" accept={aceita} multiple={multiplo} onChange={(e) => receber(e.target.files)} />
    </label>
  );
}
